import { api } from "./api";
import { atom } from 'jotai';
import { store } from "./atom.service";
import type { MeDto } from '../../../shared/types/access';

export type User = MeDto;

/** 0 = not loaded yet, null = signed out. */
export const authAtom = atom<User | null | 0>(0);

/** Send the browser to Persera sign-in, returning to `contPath` (default: where we are now). */
export function login(contPath?: string, authmethod?: string) {
    const url = contPath ? new URL(contPath, window.location.origin).href : window.location.href;
    let next = `/auth/login?cont=${encodeURIComponent(url)}`;
    if (authmethod) {
        next += `&method=${authmethod}`;
    }
    window.location.href = next;
}

export function logout() {
    api.post('/auth/logout').finally(() => {
        store.set(authAtom, null);
        window.location.href = '/';
    });
}

/** Load the signed-in user. `refresh` rereads the subscription from the hub (e.g. after checkout). */
export async function getProfile(refresh = false): Promise<User | null> {
    try {
        const { data } = await api.get<MeDto>('/api/me', refresh ? { params: { refresh: 1 } } : undefined);
        store.set(authAtom, data);
        return data;
    } catch {
        store.set(authAtom, null);
        return null;
    }
}
